module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-cartaz-divulgacao-768x591.810b97ae.jpg";